/** @module Operations/Review/ViewPDFRenderer */
define([
	"dojo/_base/declare",
	"csi",
	"csi/comm",
	"csi/heading/Url",
	"csi/html"
], function(declare, csi, comm, Url, html) {

	return declare(Url, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render PDF icon if file present
			var value = this._getValue(ctx, h);
			var node = ctx.getNode();

			if (!node[this.getIdStatus(h)] && value && (value != csi.EMPTY_URL)) {
				return this.inherited(arguments);
			}

			return false;
		},

		/**
		 * @override
		 * Handle change to attribute value while monitoring  DE21001
		 */
		onMonitor: function(amc, newValue) {
			amc.ctx.view.redraw();
			return true;
		}
	});
});